document.addEventListener('DOMContentLoaded', function () {

  /* Sticky header */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* Mobile menu */
  var btn = document.querySelector('.mobile-menu-btn');
  var menu = document.querySelector('.mobile-menu');
  if (btn && menu) {
    btn.addEventListener('click', function () {
      menu.classList.toggle('open');
    });
  }

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && window.IntersectionObserver) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { obs.observe(el); });
  }

  /* Count-up */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && window.IntersectionObserver) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.dataset.countup, 10);
        var suffix = el.dataset.suffix || '';
        var start = null;
        var dur = 1800;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.floor(ease * target) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        co.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { co.observe(el); });
  }

  /* Horizontal scroll */
  document.querySelectorAll('.hscroll-container').forEach(function (container) {
    var track = container.querySelector('.hscroll-track');
    var panels = container.querySelectorAll('.hscroll-panel');
    var dots = container.querySelectorAll('.hscroll-dot');
    var arrows = container.querySelector('.hscroll-arrows');
    var counter = container.querySelector('.hscroll-counter');
    var n = panels.length;
    if (!track || n < 2) return;
    var currentX = 0;
    function tick() {
      var rect = container.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      var raw = scrollable > 0 ? -rect.top / scrollable : 0;
      var progress = Math.max(0, Math.min(1, raw));
      var targetX = -progress * (n - 1) * window.innerWidth;
      currentX += (targetX - currentX) * 0.09;
      track.style.transform = 'translateX(' + currentX + 'px)';
      var active = Math.round(progress * (n - 1));
      dots.forEach(function (d, i) { d.classList.toggle('active', i === active); });
      if (arrows) arrows.style.opacity = active < n - 1 ? '1' : '0';
      if (counter) counter.textContent = '0' + (active + 1) + ' / 0' + n;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });

  /* Product filter */
  document.querySelectorAll('.filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var cat = btn.dataset.filter;
      document.querySelectorAll('.product-card[data-category]').forEach(function (card) {
        card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
      });
    });
  });

  /* Add to cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-btn');
    if (!btn) return;
    btn.classList.add('added');
    btn.textContent = '✓ Added';
    var cc = document.querySelector('.cart-count');
    if (cc) cc.textContent = (parseInt(cc.textContent) || 0) + 1;
    setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = '<span>🛍</span> Add'; }, 1500);
  });

  /* Wishlist */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;
    var on = btn.classList.toggle('active');
    btn.style.background = on ? 'var(--rose)' : 'white';
    btn.textContent = on ? '❤️' : '🤍';
  });

  /* Customize picker */
  var picker = document.querySelector('.product-picker__grid');
  var fill = document.querySelector('.customize-panel__progress-fill');
  var cnt = document.querySelector('.customize-progress-count');
  var cta = document.querySelector('.customize-cta');
  var MAX = 6;
  var selected = {};
  if (picker) {
    picker.addEventListener('click', function (e) {
      var item = e.target.closest('.picker-item');
      if (!item || item.disabled) return;
      var id = item.dataset.id;
      if (selected[id]) {
        delete selected[id];
        item.classList.remove('selected');
        var chk = item.querySelector('.picker-item__check');
        if (chk) chk.remove();
      } else if (Object.keys(selected).length < MAX) {
        selected[id] = true;
        item.classList.add('selected');
        if (!item.querySelector('.picker-item__check')) {
          var c = document.createElement('div');
          c.className = 'picker-item__check';
          c.textContent = '✓';
          item.appendChild(c);
        }
      }
      var n = Object.keys(selected).length;
      picker.querySelectorAll('.picker-item').forEach(function (i) {
        i.disabled = !selected[i.dataset.id] && n >= MAX;
      });
      if (fill) fill.style.width = (n / MAX * 100) + '%';
      if (cnt) cnt.textContent = n + ' / ' + MAX;
      if (cta) {
        if (n === MAX) {
          cta.textContent = '📱 Order via WhatsApp';
          cta.style.background = 'var(--gold)';
          cta.style.opacity = '1';
          cta.style.pointerEvents = 'auto';
        } else {
          cta.textContent = 'Select ' + (MAX - n) + ' more item' + (MAX - n !== 1 ? 's' : '');
          cta.style.background = 'rgba(255,255,255,0.1)';
          cta.style.opacity = '0.5';
          cta.style.pointerEvents = 'none';
        }
      }
    });
  }

  /* Newsletter */
  var nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      nlForm.innerHTML = '<div style="padding:14px 28px;background:var(--primary);color:white;border-radius:999px;font-weight:700;font-size:13px;">✓ You\'re on the list!</div>';
    });
  }

  /* Hero float animation */
  var cards = document.querySelectorAll('.hero__card--main, .hero__card--secondary, .hero__card--small');
  if (cards.length) {
    var t = 0;
    function floatCards() {
      t += 0.018;
      cards.forEach(function (card, i) {
        var y = Math.sin(t + i * 0.8) * (8 - i * 2);
        card.style.transform = 'translateY(' + y + 'px)';
      });
      requestAnimationFrame(floatCards);
    }
    requestAnimationFrame(floatCards);
  }

});
